import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <section className="relative py-32 bg-gold-wash z-20 border-t border-gold/40" data-id="element-11" data-mp="c70xh92updo1">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-12" data-mp="84ntoq7nzptw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-13" data-mp="87jq2a3v66g8">
          <h2 className="font-serif text-5xl md:text-7xl text-ink mb-8" data-id="element-14" data-mp="qwq43jtpq9vp">
            ¿Listo para tu{' '}
            <span className="text-gold-deep italic" data-id="element-15" data-mp="14w7v85uhdz88">transformación?</span>
          </h2>
          <p className="font-sans text-lg text-ink-soft mb-12 max-w-2xl mx-auto" data-id="element-16" data-mp="zxehccba867j">
            Da el primer paso hacia la sonrisa que siempre has deseado. Agenda
            una evaluación privada con nuestros especialistas.
          </p>

          <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} transition={{
          duration: 0.16,
          ease: [0.23, 1, 0.32, 1]
        }} className="inline-block bg-gold text-ink px-10 py-5 rounded-sm font-semibold text-base md:text-lg uppercase tracking-widest hover:bg-gold-deep hover:text-white transition-colors shadow-[0_10px_30px_rgba(201,162,39,0.35)]" data-id="element-17" data-mp="2h5u36s960qeo">
            Reservar Sesión VIP
          </motion.a>
        </motion.div>
      </div>
    </section>;
}